import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@quorum/api';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { Note } from '@quorum/models/xs-resource';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';
import { AuthenticatedUser } from 'libs/authentication/src/lib/+state/authentication.interfaces';
import { Observable } from 'rxjs';

@Component({
  selector: 'svc-customer-notes-dialog',
  templateUrl: './customer-notes-dialog.component.html',
  styleUrls: ['./customer-notes-dialog.component.scss'],
})
export class CustomerNotesDialogComponent implements OnInit {
  allNotes$: Observable<any>;

  customerNoteForm = this.fb.group({
    customerNote: ['', Validators.required],
  });
  appointmentNoteForm = this.fb.group({
    appointmentNote: ['', Validators.required],
  });
  vehicleNoteForm = this.fb.group({
    vehicleNote: ['', Validators.required],
  });

  currentUser$: Observable<AuthenticatedUser>;
  disableAddButton: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CustomerNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService,
    private fb: FormBuilder,
    private authenticationStateService: AuthenticationStateService,
    public serviceLaneFacade: ServiceLaneFacade
  ) {}

  ngOnInit() {
    this.currentUser$ = this.authenticationStateService.selectAuthenticatedUser();

    this.allNotes$ = this.serviceLaneFacade.allNotes$;
  }

  AddCustomerNote(note: string, notes: Note, currentUser: AuthenticatedUser, associateId: string) {
    this.disableAddButton = true;
    let currentDate = new Date();
    let newNote: Note;
    let formattedCurrentDateTime = `${[
      currentDate.getMonth() + 1,
      currentDate.getDate(),
      currentDate.getFullYear(),
    ].join('/')} ${[currentDate.getHours(), ('0' + currentDate.getMinutes()).slice(-2)].join(':')}`;
    if (notes) {
      newNote = {
        ...notes,
        notes: `${currentUser.user.firstName} ${currentUser.user.lastName} ${formattedCurrentDateTime} ${note}\r\n${notes.notes}`,
      };
      this.serviceLaneFacade.updateNotes(newNote, 'customer');
      this.disableAddButton = false;
    } else {
      newNote = {
        ...new Note(),
        functionalAreaId: 'CU',
        notes: `${currentUser.user.firstName} ${currentUser.user.lastName} ${formattedCurrentDateTime} ${note}`,
        sourceReference1Id: associateId,
        sourceReference2Id: 'N',
      };
      this.serviceLaneFacade.createNotes(newNote, 'customer');
      this.disableAddButton = false;
    }
    this.customerNoteForm.get('customerNote').setValue('');
  }

  AddAppointmentNote(note: string, notes: Note, currentUser: AuthenticatedUser, appointmentId: string) {
    this.disableAddButton = true;
    let currentDate = new Date();
    let newNote: Note;
    let formattedCurrentDateTime = `${[
      currentDate.getMonth() + 1,
      currentDate.getDate(),
      currentDate.getFullYear(),
    ].join('/')} ${[currentDate.getHours(), ('0' + currentDate.getMinutes()).slice(-2)].join(':')}`;
    if (notes) {
      newNote = {
        ...notes,
        notes: `${currentUser.user.firstName} ${currentUser.user.lastName} ${formattedCurrentDateTime} ${note}\r\n${notes.notes}`,
      };
      this.serviceLaneFacade.updateNotes(newNote, 'appointment');
      this.disableAddButton = false;
    } else {
      newNote = {
        ...new Note(),
        functionalAreaId: 'SA',
        notes: `${currentUser.user.firstName} ${currentUser.user.lastName} ${formattedCurrentDateTime} ${note}`,
        sourceReference1Id: appointmentId,
        sourceReference2Id: 'N',
      };
      this.serviceLaneFacade.createNotes(newNote, 'appointment');
      this.disableAddButton = false;
    }
    this.appointmentNoteForm.get('appointmentNote').setValue('');
  }

  AddVehicleNote(note: string, notes: Note, currentUser: AuthenticatedUser, vehicleId: string) {
    this.disableAddButton = true;
    let currentDate = new Date();
    let newNote: Note;
    let formattedCurrentDateTime = `${[
      currentDate.getMonth() + 1,
      currentDate.getDate(),
      currentDate.getFullYear(),
    ].join('/')} ${[currentDate.getHours(), ('0' + currentDate.getMinutes()).slice(-2)].join(':')}`;
    if (notes) {
      newNote = {
        ...notes,
        notes: `${currentUser.user.firstName} ${currentUser.user.lastName} ${formattedCurrentDateTime} ${note}\r\n${notes.notes}`,
      };
      this.serviceLaneFacade.updateNotes(newNote, 'vehicle');
      this.disableAddButton = false;
    } else {
      newNote = {
        ...new Note(),
        functionalAreaId: 'VE',
        notes: `${currentUser.user.firstName} ${currentUser.user.lastName} ${formattedCurrentDateTime} ${note}`,
        sourceReference1Id: vehicleId,
        sourceReference2Id: 'N',
      };
      this.serviceLaneFacade.createNotes(newNote, 'vehicle');
      this.disableAddButton = false;
    }
    this.vehicleNoteForm.get('vehicleNote').setValue('');
  }
}
